import { render, staticRenderFns } from "./view_branding.vue?vue&type=template&id=bb862538&scoped=true"
import script from "./view_branding.vue?vue&type=script&lang=js"
export * from "./view_branding.vue?vue&type=script&lang=js"
import style0 from "./view_branding.vue?vue&type=style&index=0&id=bb862538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb862538",
  null
  
)

export default component.exports